import styled from "styled-components";
import { media, theme } from "../../../../../helpers/theme";


export type AdditionalInfoPropertyItem = {
    propertyKey: string,
    propertyName: string,
    propertyValue: string,
}

interface SummaryProps {
    data: AdditionalInfoPropertyItem[],
}

export const AdditionalInfo = (props: SummaryProps) => {
    return (
        <Wraper>
            {props.data.map((property, index) => (
                <div key={index}>
                    {property.propertyValue
                        ?
                        <InfoWraper key={property.propertyKey}>
                            <ItemName>{property.propertyName}:</ItemName>
                            <ItemValue>{property.propertyValue}</ItemValue>
                        </InfoWraper >
                        :
                        <></>}
                </div>
            ))}
        </Wraper>
    );
};
const Wraper = styled.div`

`
const InfoWraper = styled.div`
display:flex;
flex-direction: row;
justify-content: start;
width:max-content;
margin-bottom: 1px;
white-space: break-spaces;
align-items: flex-start;
width:100%;
padding-bottom:10px;

@media (max-width:299px){
    justify-content: space-between !important;
}
`;
const ItemName = styled.div`
padding: 0px 0px;
color:${theme.colors.gray01_secondaryText};
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
 @media (max-width:950px) and (min-width:300px){
    min-width:143px;
}
@media  (min-width:951px){
    min-width:170px;
}`;

const ItemValue = styled.div`
padding: 0px 0px 0px 10px;
font-family: ${theme.fonts.interRegular};
font-style : normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px; 
line-height: 20 px; 
color: ${theme.colors.black_primaryText};
overflow-wrap: break-word;
align-content:center;
white-space: break-spaces;
@media(max-width: 299px) {
    text-align: right;
}
`;    
